import React from 'react'
import { TextField, Typography } from '@mui/material'

const styles = {
    root: { display: 'flex', flexDirection: 'column', width: '100%', minWidth: 0 },
    title: { fontSize: '1rem' },
    input: { width: '100%' },
}

export default function GridFilterHeader({ title, field, filterValue, onFilter, id, type = 'text', disabled = false }) {
    return (
        <Typography component='div' sx={styles.root}>
            <Typography variant='caption' sx={styles.title}>{title}</Typography>
            <TextField
                variant='standard'
                type={type}
                value={filterValue ?? ''}
                disabled={disabled}
                onClick={(event) => event.stopPropagation()}
                onKeyDown={(event) => event.stopPropagation()}
                onChange={(event) => onFilter(field, event.target.value)}
                sx={styles.input}
                inputProps={{ id, 'aria-label': `Search ${title}` }}
            />
        </Typography>
    )
}
